export const normalizeTimeField = value => {
  const matched = `${value}`.match(/(\d)+(\.|,)?(\d){0,}/);
  const re = /(\.|,)/;
  const formatted = matched ? matched[0].replace(re, '') : '';

  return formatted ? Number(formatted) : '';
};
